import { DsIcon } from '@ice-web-app/designSystem';
import { loadModuleNamespace } from '@ice-web-app/shared-i18n';
import { useGlobalStore, useSidebarStore } from '@ice-web-app/shared-store';
import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { smartAR, smartDE, smartEN } from '../locales';
import { ZoneRoutes } from '../routes/ZoneRoutes';
import { routes } from '../routes/routes';
import { VoiceInputButton } from './voice/VoiceInputButton';
import { VoiceInputProvider } from './voice/VoiceInputContext';

export const SmartZone: FC = () => {
  const { setMenuItems, setEntityMenuItems, setShowEntityMenu, setBackPath } = useSidebarStore();
  const { setShowMainSidebar } = useGlobalStore();
  const showMainSidebar = localStorage.getItem('showMainSidebar') === 'true';
  const location = useLocation();

  useEffect(() => {
    setShowMainSidebar(showMainSidebar);
  }, [showMainSidebar]);

  // Check if we are on an entity route
  useEffect(() => {
    const isEntityRoute = location.pathname.includes('/entity/');
    const entityIdMatch = location.pathname.match(/\/entity\/([^/]+)\//);
    const entityId = entityIdMatch ? entityIdMatch[1] : null;

    if (isEntityRoute && entityId) {
      // Show entity menu
      setShowEntityMenu(true);
      setEntityMenuItems([
        {
          title: 'Back',
          icon: <DsIcon icon="ARROW_LEFT" />,
          path: routes.hub,
          isEntityMenu: true,
          isBackButton: true,
        },
        {
          title: 'Source Material',
          icon: <DsIcon icon="FOLDER" />,
          path: routes.entitySourceMaterial(entityId),
          isEntityMenu: true,
        },
        {
          title: 'Requirements Document',
          icon: <DsIcon icon="MOVE_TO_FOLDER" />,
          path: routes.entityDocument(entityId),
          isEntityMenu: true,
        },
        {
          title: 'Requirements Review',
          icon: <DsIcon icon="ENQUIRY_PIPELINE" />,
          path: routes.entityReview(entityId),
          isEntityMenu: true,
        },
        {
          title: 'Sidebar',
          icon: <DsIcon icon="BULLETED_LIST" />,
          path: routes.entitySlider(entityId),
          isEntityMenu: true,
        },
        {
          title: 'Design Preview',
          icon: <DsIcon icon="EYE_OPENED" />,
          path: routes.designPreview(entityId),
          isEntityMenu: true,
        },
        // {
        //   title: 'Prototype',
        //   icon: <DsIcon icon="BRAND_KIT" />,
        //   path: '/',
        //   isEntityMenu: true,
        //   disabled: true,
        // },
      ]);
    } else {
      // Show regular menu
      setShowEntityMenu(false);
      setEntityMenuItems([]);
    }
  }, [location.pathname]);

  useEffect(() => {
    setBackPath(getCurrentEcosystemBasePath() || '/');

    setMenuItems([
      {
        title: 'My Hub',
        icon: <DsIcon icon="FOLDER" />,
        path: routes.hub,
      },
      {
        title: 'Instructions',
        icon: <DsIcon icon="INFO_OCTAGON" />,
        path: routes.agent,        
      },
    ]);

    return () => {
      setBackPath('');
    };
  }, []);

  useEffect(() => {
    loadModuleNamespace('smartZone', [
      { jsonFile: smartAR, lang: 'ar' },
      { jsonFile: smartDE, lang: 'de' },
      { jsonFile: smartEN, lang: 'en' },
    ]);
  }, []);

  return (
    <VoiceInputProvider>
      <ZoneRoutes />
      <VoiceInputButton />
    </VoiceInputProvider>
  );
};
export default SmartZone;
